import Groups from '@/components/pages/group/Groups.vue'
import GroupListRouter from '@/components/pages/group/index.vue'
import GroupCreate from '@/components/pages/group/GroupCreate.vue'
import GroupEdit from '@/components/pages/group/GroupEdit.vue'
import GroupStudentMove from '@/components/pages/group/GroupStudentMove.vue'

export default {
  path: '/groups',
  name: 'GroupListRouter',
  component: GroupListRouter,
  children: [
    {
      path: '/groups',
      component: Groups,
      name: 'Groups',
      meta: {
        acceptRoles: ['admin'],
      },
    },
    {
      path: '/groups/create',
      component: GroupCreate,
      name: 'GroupCreate',
      meta: {
        acceptRoles: ['admin'],
      },
    },
    {
      path: '/groups/:groupId/edit',
      component: GroupEdit,
      name: 'GroupEdit',
      meta: {
        acceptRoles: ['admin'],
      },
    },
    {
      path: '/groups/:groupId/students/:studentId/move',
      component: GroupStudentMove,
      name: 'GroupStudentMove',
      meta: {
        acceptRoles: ['admin'],
      },
    },
  ],
}
